import { ResendVerificationEmailService } from './service/resend-verification-email.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from '../common-service/local-storage/local-storage.service';
import { ServiceUrlsService } from '../common-service/service-urls/service-urls.service';

@Component({
  selector: 'app-signup-success',
  templateUrl: './signup-success.component.html',
  styleUrls: ['./signup-success.component.scss']
})
export class SignupSuccessComponent implements OnInit {

  contactEmail: string;
  resendEmailMessage = '';
  signUpSuccess = false;
  verificationEmailSent= false;
  subscriptionMessage = '';
  constructor(private activeRoute: ActivatedRoute,
              private spinnerService: NgxSpinnerService,
              private resendEmailService: ResendVerificationEmailService,
              private localStorageService: LocalStorageService,
              private serviceUrls : ServiceUrlsService) { }

  ngOnInit() {
    //this.contactEmail = this.activeRoute.snapshot.params.email;
    this.subscriptionMessage = '';
  }

  resendVerificationLink() {
      console.log(this.contactEmail);

     let emailObject = {contactEmail: this.contactEmail};
     this.spinnerService.show();
     this.resendEmailMessage = '';

     this.resendEmailService.resendVerificationEmail(emailObject).subscribe(response => {
        let status = response.status;
        console.log(response);
        if (status === '100' || status === 100) {
            this.resendEmailMessage = response.message;
            this.signUpSuccess =  true;
            this.spinnerService.hide();
        } else {
            this.resendEmailMessage = response.message;
            this.spinnerService.hide();
        }
    },
      err => {
          console.log(err);
          this.resendEmailMessage = err.message;
           this.spinnerService.hide();
    });
  }

  goToXeyePortal(): void {
    window.open(this.serviceUrls.portalUrl, "_blank");

  }

}



// WEBPACK FOOTER //
// ./src/app/signup-success/signup-success.component.ts